import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { AccessPortal, BackdropLoader, ExpandedTooltip, Icon, toast } from '@livable/saas-react-components';
import { Container, Chip, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TeamMemberMenu from 'src/pages/TeamSettingsPage/TeamMemberMenu';
import AddTeamMemberModal from 'src/components/settings/AddTeamMemberModal';
import EditTeamMemberModal from 'src/components/settings/EditTeamMemberModal';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { TEAM_MEMBER_ROLES_BY_NAMES, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
export const MembersTab = observer(_ref => {
  let hideActionsBar = _ref.hideActionsBar,
    former = _ref.former;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenEditModal = _useState2[0],
    setIsOpenEditModal = _useState2[1];
  const _useState3 = useState({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      accountId: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    editUserData = _useState4[0],
    setEditUserData = _useState4[1];
  const handleEditModal = accountId => {
    const teamMember = store.teamMembers.getTeamMemberByAccountId(accountId);
    if (teamMember) {
      var _teamMember$email;
      setEditUserData({
        firstName: teamMember.firstName,
        lastName: teamMember.lastName,
        email: (_teamMember$email = teamMember.email) !== null && _teamMember$email !== void 0 ? _teamMember$email : teamMember.newEmail,
        phone: teamMember.phone ? teamMember.phone.replace('+1', '').replace('+38', '') : '',
        accountId: teamMember.accountId
      });
      setIsOpenEditModal(true);
    }
  };
  const handleEditModalClose = () => {
    setIsOpenEditModal(false);
    setEditUserData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      accountId: ''
    });
  };
  const handleResendInvite = async accountId => {
    const reInviteUserResp = await store.account.reInviteUserAsync.run(accountId);
    if (!reInviteUserResp || !reInviteUserResp.isSuccessful) return;
    toast('success', {
      body: ['Re-invitation successfully sent']
    });
  };
  const asyncDataLoading = async () => {
    const resp = await store.teamMembers.getCompanyTeamMembersAsync.run({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    if (!resp || !resp.isSuccessful) return;
  };
  const handleEditModalSuccess = () => {
    asyncDataLoading();
  };
  const handleDeactivateSuccess = () => {
    asyncDataLoading();
  };
  useEffect(() => {
    asyncDataLoading();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(Container, {
    className: "".concat(classes.lgSection, " ").concat(classes.container)
  }, !hideActionsBar && /*#__PURE__*/React.createElement("div", {
    className: classes.actionBar
  }, /*#__PURE__*/React.createElement(AddTeamMemberModal, {
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      variant: "action",
      'custom-attribute': '830-team-settings-page-members-tab'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "user-add"
    }), t('team_page.add_new_team_member')),
    handleEditModalSuccess: handleEditModalSuccess
  }), /*#__PURE__*/React.createElement(EditTeamMemberModal, {
    isOpen: isOpenEditModal,
    data: editUserData,
    handleClose: handleEditModalClose,
    handleEditModalSuccess: handleEditModalSuccess
  })), store.teamMembers.companyTeamMembers.length > 0 && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    className: classes.membersTable,
    "aria-label": "team members table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.roleCell
  }, t('team_page.role')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.portalCell
  }, t('team_page.portal')), /*#__PURE__*/React.createElement(TableCell, null, t('team_page.name')), /*#__PURE__*/React.createElement(TableCell, null, t('team_page.email_address')), /*#__PURE__*/React.createElement(TableCell, null, t('team_page.phone')), !former && /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('team_page.toolbox')))), /*#__PURE__*/React.createElement(TableBody, null, store.teamMembers.getTeamMember(former).map(member => {
    var _member$email;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: member.id
    }, /*#__PURE__*/React.createElement(TableCell, null, t(TEAM_MEMBER_ROLES_BY_NAMES[member.userRole])), /*#__PURE__*/React.createElement(TableCell, null, !former && member.emailConfirmed && /*#__PURE__*/React.createElement(AccessPortal, {
      tooltipText: t('team_page.has_access_to_portal'),
      type: "success"
    }), !former && !member.emailConfirmed && /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        handleResendInvite(member.accountId);
      }
    }, /*#__PURE__*/React.createElement(AccessPortal, {
      tooltipText: t('team_page.pending_invite'),
      type: "warning"
    })), former && /*#__PURE__*/React.createElement(ExpandedTooltip, {
      placement: "top",
      title: t('team_page.access_revoked'),
      type: "default"
    }, /*#__PURE__*/React.createElement(Chip, {
      className: classes.status,
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "lock-locked"
      }),
      size: "big",
      variant: "inactiveIcon"
    }))), /*#__PURE__*/React.createElement(TableCell, null, member.firstName, " ", member.lastName, ' '), /*#__PURE__*/React.createElement(TableCell, null, (_member$email = member.email) !== null && _member$email !== void 0 ? _member$email : member.newEmail), /*#__PURE__*/React.createElement(TableCell, null, member.phone), !former && /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      onClick: () => {
        handleEditModal(member.accountId);
      },
      'custom-attribute': '832-team-settings-page-members-tab'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    })), /*#__PURE__*/React.createElement(TeamMemberMenu, {
      member: member,
      handleEditModal: handleEditModal,
      handleResendInvite: handleResendInvite,
      handleDeactivateSuccess: handleDeactivateSuccess
    })));
  })))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.teamMembers.getCompanyTeamMembersAsync.inProgress
  }));
});